module.exports = __webpack_public_path__ + "img/logo-icon.6f9c79f7.png";